module.exports = __webpack_public_path__ + "static/img/23-real-estate-finance.18b94e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/Icon/23-real-estate-finance.png
// module id = DOA7
// module chunks = 1